import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'kind': 'String!',
	'transport_kind': 'String',
	'reason': 'String',
	'booking_date': 'String!',
	'building_guid': 'String!',
	'floor_guid': 'String!',
	'room_guid': 'String',
	'table_guid': 'String',
	'timeslot_guid': 'String!',
	'employee_guid': 'String!',
	'lunch_option_guids': '[String]',
	'license_plate': 'String',
	'building_parking_space_guid': 'String',
	'employee_booking_invitation_guid': 'String',
	'status': 'String',
};

export default gql(`
	mutation create_employee_booking( ${ HelperGraphql.createFields( fields ) } ) {
	    create_employee_booking( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        kind
	        
	        employee {
	            guid
            }
	    }
	}
`);

